export const isGameflares = window.location.hostname.includes("gameflares")
  ? //  || window.location.hostname.includes('localhost')
    true
  : false;

export const isGamiway = window.location.hostname.includes("gamiway")
  ? //  || window.location.hostname.includes('localhost')
    true
  : false;

export const isGamelords = window.location.hostname.includes("game-lords")
  ? //  || window.location.hostname.includes('localhost')
    true
  : false;

export const isPlaynixzone = window.location.hostname.includes("playnixzone")
  ? // || window.location.hostname.includes("localhost")
    true
  : false;

export const isFunzarena =
  window.location.hostname.includes("funzarena") ||
  window.location.hostname.includes("localhost")
    ? true
    : false;

export const isgamiHub = window.location.hostname.includes("gami-hub") //||window.location.hostname.includes("localhost")
  ? true
  : false;

export const isThegamingclubs = window.location.hostname.includes(
  "thegamingclubs",
)
  ? // || window.location.hostname.includes("localhost")
    true
  : false;

export const isGamesqueens = window.location.hostname.includes("gamesqueens")
  ? // || window.location.hostname.includes("localhost")
    true
  : false;

export const isGameverselt = window.location.hostname.includes("gameverse-lt")
  ? // || window.location.hostname.includes("localhost")
    true
  : false;



// WEBPACK FOOTER //
// ./src/constants/productCondition.js